<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">{{ add_day }}日业绩明细</div>
          <div class="money">
            团队:<span class="num">{{ commission }}</span>元 <span class="num">{{ commission_pv }}</span>C<br />
            个人:<span class="num">{{ my_commission }}</span>元 <span class="num">{{ my_commission_pv }}</span>C
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record sign-record1 bill-details" ref="content">
      <div class="nav acea-row">

        <div class="item" :class="type === 0 ? 'on' : ''" @click="changeTypes(0)" >
          团队业绩
        </div>
        <div class="item" :class="type === 1 ? 'on' : ''" @click="changeTypes(1)" >
          个人业绩
        </div>
      </div>


      <div class="list">
        <div class="item" v-for="(val, index) in info" :key="index">

          <div class="listn" >
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ val.account }} ({{ val.nickname }})</div>
                <div>{{ val._add_time }}</div>
              </div>
              <div class="num" >￥{{ val.total_price }}元 {{ val.total_pv }}C</div>
              <div style="clear:both;"></div>
              <div style="width:100%;" >订单号：{{ val.order_id }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .sign-record1 .list .item .listn .itemn .num {
    width: 3rem;
    text-align: right;
    color:#282828;
  }
</style>
<script>
    import { getIncomeList } from "../../../api/user";
    import Loading from "@components/Loading";
    const NAME = "Income";
    export default {
        name: NAME,
        components: {
            Loading
        },
        props: {},
        data: function() {
            return {
                info: [],
                commission: 0,
                commission_pv: 0,

                my_commission: 0,
                my_commission_pv: 0,

                where: {
                    page: 1,
                    limit: 20,
                    type:0,
                    add_day:this.$route.params.add_day,
                },
                add_day:this.$route.params.add_day,
                type: 0,
                loaded: false,
                loading: false
            };
        },
        watch: {
            $route(n) {
                if (n.name === NAME) {
                    this.commission = 0;
                    this.commission_pv = 0;

                    this.my_commission = 0;
                    this.my_commission_pv = 0;

                    this.info = [];
                    this.where.add_day = this.$route.params.add_day;
                    this.add_day = this.$route.params.add_day;
                    this.loaded= false;
                    this.loading= false;
                    this.where.page = 1;
                    this.where.type = 0;
                    this.type = 0;
                    this.getIndex();
                }
            }
        },
        mounted: function() {

            this.getIndex();
            this.$scroll(this.$refs.container, () => {
                this.loading === false && this.getIndex();
        });
        },
        methods: {
            changeTypes(type) {
                this.type = type;
                this.info = [];
                this.where.page = 1;
                this.where.type = type;
                this.loaded = false;
                this.loading = false;
                this.getIndex();
            },
            getIndex: function() {
                let that = this;
                if (that.loading == true || that.loaded == true) return;
                that.loading = true;
                getIncomeList(that.where).then(
                    res => {
                    that.loading = false;
                    that.loaded = res.data.list.length < that.where.limit;
                    that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
                    that.where.page = that.where.page + 1;
                    that.info.push.apply(that.info, res.data.list);
                    that.commission = res.data.teammoney;
                    that.commission_pv = res.data.teampv;
                    that.my_commission = res.data.mymoney;
                    that.my_commission_pv = res.data.mypv;
                },
                error => {
                    that.$dialog.message(error.msg);
                }
            );
            },

        }
    };
</script>